<template>
  <div>
    <a-form
      ref="formRef"
      class="form selectors"
      :model="formState"
      :rules="rules"
      layout="vertical"
    >
      <a-form-item v-if="user?.customer?.type_business == 1" label="Empresa" name="entity">
        <entity-picker :value="formState.entity" @update:value="formState.entity = $event" />
      </a-form-item>
      <a-form-item label="Campaña" name="campaign">
        <campaign-picker
          :showAll="false"
          :value="formState.campaign"
          @update:value="formState.campaign = $event"
          :entity="formState.entity"
        />
      </a-form-item>
      <a-form-item v-if="user?.customer?.enable_bases" label="Base" name="base">
        <bases-picker
          :value="formState.base"
          @update:value="formState.base = $event"
          :entity="formState.entity"
          :portfolio="formState.campaign"
        />
      </a-form-item>
      <a-form-item label="Usuarios" name="user">
        <selector-users v-model:value="formState.user" />
      </a-form-item>
      <PlanSeparatedDatePicker
        v-model:startDate="formState.startDate"
        v-model:endDate="formState.endDate"
        startPlaceholder="-- / -- / ----"
        endPlaceholder="-- / -- / ----"
        :valueFormat="null"
      >
        <template #start-label>
          <span class="label" v-if="typeReport != 7">Fecha de inicio</span>
          <span class="date__start" v-else>Fecha de inicio de PDP </span>
        </template>

        <template #end-label>
          <span class="label" v-if="typeReport != 7">Fecha de fin</span>
          <span class="date__end" v-else> Fecha de fin de PDP </span>
        </template>
      </PlanSeparatedDatePicker>
      <div v-if="!user?.customer?.type_business == 1"></div>
      <div v-if="!user?.customer?.enable_bases"></div>
      <div class="back" v-if="user?.customer?.enable_bases">
        <a-button type="primary" :disabled="!isDisabled || loadingSearch" :loading="loadingSearch" @click="handleSearch">
          Buscar
          <SearchOutlined />
        </a-button>
        <div class="download">
          <span class="total" v-if="countReport > -1">{{ countReport }} Registros</span>

          <a-tooltip :title="isGlobalDownloading ? 'Tiene una descarga pendiente' : null">
            <a-button
              type="link"
              :disabled="!isDisabled || isGlobalDownloading"
              :loading="isLoading"
              @click="handleDownload"
              class="button__download"
              v-if="typeReport != 4"
            >
              Descargar
              <DownloadOutlined />
            </a-button>
          </a-tooltip>
        </div>
      </div>
      <div class="back" :class="isHideBase ? 'flex' : ''" v-else>
        <span class="totalReport" v-if="countReport > -1">{{ countReport }} Registros</span>
        <div class="download" :class="isHideBase ? 'buttonDownload' : ''">
          <a-tooltip :title="isGlobalDownloading ? 'Tiene una descarga pendiente' : null">
            <a-button
              type="link"
              :disabled="!isDisabled || isGlobalDownloading"
              :loading="isLoading"
              @click="handleDownload"
              class="button__download"
            >
              Descargar
              <DownloadOutlined />
            </a-button>
          </a-tooltip>
        </div>
        <a-button type="primary" :disabled="!isDisabled || loadingSearch" :loading="loadingSearch" @click="handleSearch">
          Buscar
          <SearchOutlined />
        </a-button>
      </div>
    </a-form>
    <div>
      <a-table
        size="middle"
        :columns="columnsTable"
        :data-source="report?.items"
        :scroll="scrollStyle"
        :pagination="showPagination ? report?.pagination : undefined"
        @change="handleTableChange"
      >
        <template #bodyCell="{ column, text }">
          <template v-if="column.key === 'document'">
            <span>{{ text.document_number }}</span>
          </template>

          <template v-if="column.key === 'contactName'">
            <span>{{ text.name }}</span>
          </template>

          <template v-if="column.key === 'contactCode'">
            <span>{{ text.code }}</span>
          </template>
        </template>

        <template #annex="{ text }">
          <span>{{ text.split("@")[0] }}</span>
        </template>

        <template #date="{ text }">
          {{ dateTimeToSlashFormat(text, false) }}
        </template>

        <template #customNameEmpty="{ record }">
          <span v-if="record.user?.name">{{ record.user?.name }}</span>
          <span v-if="!record.user?.name">--</span>
        </template>

        <template #customAnnexEmpty="{ record }">
          <span v-if="record.user?.annex">{{ record.user?.annex }}</span>
          <span v-if="!record.user?.annex">--</span>
        </template>

        <template #customSubmotiveEmpty="{ record }">
          <span v-if="record.submotive">{{ record.submotive }}</span>
          <span v-if="!record.submotive">--</span>
        </template>

        <template #account="{ text }">
          <span v-if="text">{{ text }}</span>
          <span v-else> -- </span>
        </template>

        <template #pdpType="{ text }">
          <span>{{ PdpTypeLabel[text] }}</span>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, onMounted, reactive, ref, toRaw, watch } from "vue";
import { useStore } from "vuex";
import { DownloadOutlined, SearchOutlined } from "@ant-design/icons-vue";

import { downloadCommonReport } from "@/app/reports/services";
import { columns } from "@/app/reports/utils/constants";
import { columnsReportSeven } from "@/app/reports/utils/constants";
import { PdpTypeLabel } from "@/app/reports/utils/enums";
import BasesPicker from "@/app/shared/components/pickers/BasesPicker.vue";
import CampaignPicker from "@/app/shared/components/pickers/CampaignPicker.vue";
import EntityPicker from "@/app/shared/components/pickers/EntityPicker.vue";
import SelectorUsers from "@/app/shared/components/selectors/SelectorUsers.vue";
import { useGlobalDownloadState } from "@/app/shared/composables/useGlobalDownloadState";
import { useScrollResize } from "@/app/shared/composables/useScrollResize";
import { dateTimeToSlashFormat } from "@/app/shared/utils/dates";
import PlanSeparatedDatePicker from "@/app/shared/components/pickers/PlanSeparatedDatePicker.vue";

const columnsReport5 = [0, 1, 3, 4, 5, 8, 15, 16, 17];
const columnsReport6 = [0, 1, 2, 3, 5, 8, 15, 16, 17];
const columnsReport7 = [0, 1, 3, 4, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 17, 18, 19];
const columnsReport8 = [0, 1, 3, 4, 5, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17];

export default defineComponent({
  components: {
    EntityPicker,
    CampaignPicker,
    BasesPicker,
    DownloadOutlined,
    SearchOutlined,
    SelectorUsers,
    PlanSeparatedDatePicker,
  },
  props: {
    typeReport: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const user = computed(() => store.getters["getDataUser"]);
    const showPagination = ref(false);
    const isLoading = ref(false);
    const loadingSearch =  ref(false);
    const formRef = ref();
    const formState = reactive({
      entity: undefined,
      campaign: undefined,
      base: undefined,
      startDate: "",
      endDate: "",
      user: undefined,
    });
    const rules = {
      entity: [{ required: user.value?.customer?.type_business == 1, message: "Campo requerido" }],
      campaign: [{ required: true, message: "Campo requerido" }],
      base: [{ required: user.value?.customer?.enable_bases, message: "Campo requerido" }],
      startDate: [{ required: true, message: "Campo requerido" }],
      endDate: [{ required: true, message: "Campo requerido" }],
      user: [],
    };

    const { scrollStyle } = useScrollResize({ headerMargin: 470 });
    const { isGlobalDownloading } = useGlobalDownloadState();
    // const scrollStyle = ref({ x: 2000, y: 500 });

    // const onResize = () => {
    //   scrollStyle.value = { x: 1800, y: window.innerHeight - 470 };
    // };

    // onBeforeUnmount(() => {
    //   window.removeEventListener("resize", onResize);
    // });

    onMounted(() => {
      formRef.value.resetFields();
      store.commit("SET_COMMON_REPORTS", []);
      showPagination.value = false;

      // table resize
      // window.addEventListener("resize", onResize);
      // scrollStyle.value = { x: 1800, y: window.innerHeight - 470 };
    });

    const isDisabled = computed(() => {
      const hasValidDateRange = formState.startDate && formState.endDate;

      if (formState.entity === 0) return hasValidDateRange;

      return (
        hasValidDateRange &&
        formState.campaign &&
        (formState.entity !== undefined || !user.value?.customer?.type_business == 1) &&
        (formState.base !== undefined || !user.value?.customer?.enable_bases)
      );
    });
    // columnsFixedTableLeft(columns)
    const report = computed(() => store.getters["getCommonReports"]);
    const countReport = computed(() => report.value?.pagination?.total);
    const columnsTable = computed(() => {
      const cols = [];
      switch (props.typeReport) {
        case 5:
          columnsReport5.forEach((index) => {
            cols.push(columns[index]);
          });
          return cols;
        case 6:
          columnsReport6.forEach((index) => {
            cols.push(columns[index]);
          });
          return cols;
        case 7:
          columnsReport7.forEach((index) => {
            cols.push(columnsReportSeven[index]);
          });
          return cols;
        case 8:
          columnsReport8.forEach((index) => {
            cols.push(columns[index]);
          });
          return cols;
        default:
          return columns;
      }
    });

    const handleDownload = async () => {
      try {
        isLoading.value = true;
        await downloadCommonReport({
          entity: toRaw(formState).entity,
          campaign: toRaw(formState).campaign,
          base: toRaw(formState).base,
          startValue: formState.startDate.format("YYYY-MM-DD"),
          endValue: formState.endDate.format("YYYY-MM-DD"),
          user: toRaw(formState).user,
          type: props.typeReport,
        });
        isLoading.value = false;
      } catch (error) {
        console.log("Error");
      }
    };

    const handleSearch = async () => {
      if (loadingSearch.value) return;
      try {
        loadingSearch.value = true;

        await store.dispatch("fetchCommonReports", {
          query: {
            entity: toRaw(formState).entity,
            campaign: toRaw(formState).campaign,
            base: toRaw(formState).base,
            startValue: formState.startDate.format("YYYY-MM-DD"),
            endValue: formState.endDate.format("YYYY-MM-DD"),
            user: toRaw(formState).user,
            type: props.typeReport,
          },
          pagination: {},
        });
        showPagination.value = true;
      } catch (error) {
        console.log("Error handleSearch multipleReports", error);
      } finally {
        loadingSearch.value = false;
      }
    };

    const handleTableChange = async (pagination) => {
      await store.dispatch("fetchCommonReports", {
        query: {
          entity: toRaw(formState).entity,
          campaign: toRaw(formState).campaign,
          base: toRaw(formState).base,
          startValue: formState.startDate.format("YYYY-MM-DD"),
          endValue: formState.endDate.format("YYYY-MM-DD"),
          user: toRaw(formState).user,
          type: props.typeReport,
        },
        pagination: pagination,
      });
    };

    watch(user, (newValue) => {
      if (newValue.customer.type_business == 2) {
        formState.entity.value = 1;
      }
    });

    return {
      dateTimeToSlashFormat,
      scrollStyle,
      formRef,
      formState,
      rules,
      user,
      isDisabled,
      countReport,
      handleDownload,
      handleSearch,
      columnsTable,
      handleTableChange,
      report,
      showPagination,
      isLoading,
      loadingSearch,
      isGlobalDownloading,
      PdpTypeLabel,
    };
  },
  computed: {
    isHideBase() {
      return !this.user?.customer?.enable_bases;
    },
  },
});
</script>

<style lang="sass" scoped>
.selectors
  display: grid
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 220px
  gap: 15px
  padding: 15px 5px 5px
:deep(.ant-calendar-picker-icon)
  top: 50% !important
:deep(.ant-calendar-picker)
  width: 100%
.back
  margin-top: 30px
  text-align: right
  margin-bottom: 10px
.main-text
  font-size: 14px
  font-style: normal
  font-weight: 400
  line-height: 28px
  letter-spacing: 0em
  text-align: center
  color: $gray-7
.total
  margin-top: 3%
  color: $gray-8

.download
  margin-top: 16px

.button__download
  padding: 0 0 0 16px

.hideBase
  display: nome !important

.flex
  display: flex
  margin-top: 30px
  position: absolute
  justify-self: flex-end
  align-items: center

.buttonDownload
  margin: 0
  padding-right: 10px

.totalReport
  color: $gray-8

.date__start
  width: 170px

.date__end
  width: 160px
</style>
